import { Injectable, Inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, of } from 'rxjs'
import { map, catchError } from 'rxjs/operators'
import { ENV_CONFIG } from 'src/app/app.config'
import { EnvConfig } from 'src/environments/environment.interface'
import { OfpPerson, OfpResponseWithMeta } from '../types/ofp.types'
import { LOGGER_SERVICE } from '../../logger/logger.config'
import { LoggerService } from '../../logger/logger.interface'

@Injectable({
  providedIn: 'root'
})
export class OfpService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    @Inject(ENV_CONFIG) private env: EnvConfig,
    @Inject(LOGGER_SERVICE) private readonly log: LoggerService
  ) {
    this.baseUrl = this.env.ofpApiUrl

    if (!this.baseUrl) {
      throw new Error('OFP API URL is required but not configured in environment')
    }
  }

  /**
   * Get OFP person by core ID
   * @param coreId - The core node ID to look up
   * @returns Observable of OfpPerson or null if not found/error
   */
  getOfpPersonByCoreId(coreId: string): Observable<OfpPerson | null> {
    if (!coreId) {
      return of(null)
    }

    const url = `${this.baseUrl}/entities/providers/core-node-person/${coreId}/person`

    return this.http.get<OfpResponseWithMeta<OfpPerson[]>>(url, { withCredentials: false }).pipe(
      map(response => response.data[0] || null),
      catchError(error => {
        this.log.warn(`Failed to fetch OFP person for core ID ${coreId}`, { error, coreId })
        return of(null)
      })
    )
  }
}
